import { FC, useMemo } from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

interface TransactionTotalMonthlyProps {
  data: {
    month: string;
    total_commission: number;
    year?: number | null;
  }[];
  startDate?: Date | null;
  endDate?: Date | null;
}

const TransactionTotalMonthly: FC<TransactionTotalMonthlyProps> = ({ data, startDate, endDate }) => {
  const filteredData = useMemo(() => {
    if (!startDate && !endDate) {
      return data.slice(-12);
    }

    return data.filter(item => {
      const monthNames = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
      ];
      const monthIndex = monthNames.findIndex(m => m === item.month);
      
      if (monthIndex === -1) return false;
      
      const year = item.year || new Date().getFullYear();
      
      const monthStartDate = new Date(year, monthIndex, 1);
      const monthEndDate = new Date(year, monthIndex + 1, 0);

      if (startDate && endDate) {
        return monthStartDate <= endDate && monthEndDate >= startDate;
      } else if (startDate) {
        return monthEndDate >= startDate;
      } else if (endDate) {
        return monthStartDate <= endDate;
      }
      
      return true;
    });
  }, [data, startDate, endDate]);

  const lastEightMonths = filteredData.length > 0 ? filteredData : data.slice(-12);
  
  const categories = lastEightMonths.map(item => item.month);
  const seriesData = lastEightMonths.map(item => item.total_commission);

  const options: ApexOptions = {
    chart: {
      type: "area",
      height: 350,
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    title: {
      text: "Total de transacciones por mes",
      align: "left",
      style: {
        fontSize: "16px",
        fontWeight: "600",
      },
    },
    xaxis: {
      categories: categories,
      labels: {
        style: {
          fontSize: "12px",
        },
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return `$${value.toLocaleString("es-MX")}`;
        },
      },
    },
    tooltip: {
      y: {
        formatter: function (value) {
          return `$${value.toLocaleString("es-MX", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        },
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.3,
        stops: [0, 90, 100],
      },
    },
    colors: ["#009714"],
  };

  const series = [
    {
      name: "Comisión",
      data: seriesData,
    },
  ];

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <ReactApexChart
        options={options}
        series={series}
        type="area"
        height={250}
      />
    </div>
  );
};

export default TransactionTotalMonthly;
